// extracted by mini-css-extract-plugin
export var text = "_av-0";